module.exports = __webpack_public_path__ + "img/type-of-platform-unity.e4814c71.webp";